export default function OutlinedLink() {
  return (
    <svg
      width="27"
      height="25"
      viewBox="0 0 27 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M26.2264 10.125C26.9409 11.3626 26.9409 12.8874 26.2264 14.125L21.5358 22.2494C20.8213 23.487 19.5008 24.2494 18.0717 24.2494L8.6905 24.2494C7.26144 24.2494 5.94093 23.487 5.2264 22.2494L0.5358 14.125C-0.178731 12.8874 -0.178731 11.3626 0.535802 10.125L5.2264 2.00064C5.94093 0.763039 7.26144 0.000643804 8.6905 0.000643867L18.0717 0.000644277C19.5008 0.000644339 20.8213 0.76304 21.5358 2.00064L26.2264 10.125Z"
        fill="#F5E8F9"
      />
      <g clipPath="url(#clip0_5942_17537)">
        <path
          d="M14.2287 14.2229C14.2082 14.2026 14.1804 14.1912 14.1515 14.1912C14.1225 14.1912 14.0948 14.2026 14.0742 14.2229L12.4855 15.8116C11.75 16.5472 10.5086 16.6251 9.69648 15.8116C8.88301 14.9981 8.96094 13.7581 9.69648 13.0226L11.2852 11.4339C11.3275 11.3915 11.3275 11.3218 11.2852 11.2794L10.741 10.7353C10.7205 10.7149 10.6927 10.7035 10.6638 10.7035C10.6348 10.7035 10.6071 10.7149 10.5865 10.7353L8.99785 12.3239C7.84121 13.4806 7.84121 15.3522 8.99785 16.5075C10.1545 17.6628 12.0262 17.6642 13.1814 16.5075L14.7701 14.9188C14.8125 14.8765 14.8125 14.8067 14.7701 14.7644L14.2287 14.2229ZM17.7643 7.74248C16.6076 6.58584 14.7359 6.58584 13.5807 7.74248L11.9906 9.33115C11.9703 9.35171 11.9589 9.37947 11.9589 9.4084C11.9589 9.43733 11.9703 9.46509 11.9906 9.48564L12.5334 10.0284C12.5758 10.0708 12.6455 10.0708 12.6879 10.0284L14.2766 8.43975C15.0121 7.7042 16.2535 7.62627 17.0656 8.43975C17.8791 9.25322 17.8012 10.4933 17.0656 11.2288L15.477 12.8175C15.4566 12.838 15.4452 12.8658 15.4452 12.8947C15.4452 12.9237 15.4566 12.9514 15.477 12.972L16.0211 13.5161C16.0635 13.5585 16.1332 13.5585 16.1756 13.5161L17.7643 11.9274C18.9195 10.7708 18.9195 8.89912 17.7643 7.74248ZM14.7223 10.2157C14.7017 10.1954 14.6739 10.1839 14.645 10.1839C14.6161 10.1839 14.5883 10.1954 14.5678 10.2157L11.4711 13.311C11.4507 13.3316 11.4393 13.3594 11.4393 13.3883C11.4393 13.4172 11.4507 13.445 11.4711 13.4655L12.0125 14.0069C12.0549 14.0493 12.1246 14.0493 12.167 14.0069L15.2623 10.9116C15.3047 10.8692 15.3047 10.7995 15.2623 10.7571L14.7223 10.2157Z"
          fill="#700F94"
        />
      </g>
      <defs>
        <clipPath id="clip0_5942_17537">
          <rect
            width="14"
            height="14"
            fill="white"
            transform="translate(6.3811 5.125)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
